import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../lib/auth.jsx";
import { Wordmark } from "../components/Brand.jsx";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [employerCode, setEmployerCode] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register({ name, email, password, employer_code: employerCode || null });
      toast.success("Account created!");
      nav("/onboarding");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-[#0a1822]">
      <div className="w-full max-w-sm">
        <Link to="/" className="block mb-10">
          <Wordmark />
        </Link>
        <h1 className="ps-heading text-3xl font-bold">Create account</h1>
        <p className="text-slate-400 mt-1">Begin your 365-day posture journey.</p>
        <form className="mt-8 space-y-4" onSubmit={submit}>
          {[
            { label: "Full Name", v: name, set: setName, type: "text", tid: "register-name" },
            { label: "Email", v: email, set: setEmail, type: "email", tid: "register-email" },
            { label: "Password", v: password, set: setPassword, type: "password", tid: "register-password" },
            { label: "Employer Code (optional)", v: employerCode, set: setEmployerCode, type: "text", tid: "register-employer", required: false },
          ].map((f) => (
            <div key={f.label}>
              <label className="text-xs uppercase tracking-widest text-slate-400 font-bold">{f.label}</label>
              <input
                data-testid={f.tid}
                type={f.type} required={f.required !== false} value={f.v}
                onChange={(e) => f.set(e.target.value)}
                className="mt-1 w-full bg-[#142534] border border-[#1a2f40] rounded-2xl px-4 py-3.5 text-white focus:border-[#2fbf71] outline-none"
              />
            </div>
          ))}
          <button data-testid="register-submit" disabled={loading} className="ps-button-primary w-full">
            {loading ? "Creating…" : "Create Account"}
          </button>
        </form>
        <p className="mt-6 text-sm text-slate-400 text-center">
          Already on Posture Steps? <Link to="/login" className="text-[#2fbf71] font-semibold" data-testid="goto-login">Log in</Link>
        </p>
      </div>
    </div>
  );
}
